module.exports = __webpack_public_path__ + "img/SES_192330255.d245c598.jpg";